const styles = {
  modelParent: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 18,
  },

  formContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridColumnGap: 25,
    gridRowGap: 10,
  },

  formLabel: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 6,
    color: '#3A3A3A',
  },

  field: {
    '& fieldset': {
      border: '1px solid #D9D9D9 !important',
    },
    '& input': {
      fontSize: 15,
    },
    '& .MuiSelect-root': {
      padding: '10px 12px !important',
      fontSize: 15,
    },
  },
  fieldError: {
    '& fieldset': {
      border: '1px solid red !important',
    },
  },

  boxDescription: {
    width: '250px !important',
  },

  buttonContainer: {
    display: 'flex',
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },

  saveButton: {
    // backgroundColor: '#FFC400 !important',
    color: '#fff !important',
    fontWeight: 600,
    borderRadius: 32,
    paddingLeft: 28,
    paddingRight: 28,
    marginLeft: 16,
    '&:disabled': {
      backgroundColor: '#ccc !important',
      color: '#666 !important',
      cursor: 'not-allowed !important',
      opacity: 0.8,
    },
  },

  icon: {
    marginRight: 6,
  },

  inputMask: {
    textAlign: 'start',
    maxWidth: 200,
    height: 40,
    padding: '0px 14px !important',
    fontSize: 15,
  },
  headerIcons: {
    margin: '0px !important',
  },
  cardIconWarning: {
    padding: '13px !important',
  },
  wrapperButtons: {
    display: 'flex',
    gap: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default styles;
